import { createBrowserRouter } from 'react-router-dom';
import { adminRoutes } from './admin';
import { portalRoutes } from './portal';
import { authRoutes } from './auth';
import { getModuleRoutes } from '@/modules/registry';

/**
 * Application router configuration using React Router v6.
 * Uses createBrowserRouter for data APIs and better error handling.
 *
 * Route arrays are composed from per-area modules:
 *   - authRoutes  — login, forbidden, setup, onboarding, dashboard, root redirects
 *   - adminRoutes — /admin/* pages (customers, orders, billing, settings, …)
 *   - portalRoutes — /portal/* customer portal + /rate/:token public page
 *
 * Order matters: more specific paths (e.g. /portal/tickets/new) appear before
 * param routes (/portal/tickets/:uuid) within each module.
 */
export const router = createBrowserRouter([
  ...authRoutes,
  ...adminRoutes,
  // Enabled-module routes are mounted here; each is gated by ProtectedRoute
  // (permission) + ModuleEnabledGate (runtime flag), so a disabled module's
  // page is unreachable. With zero modules in the repo this is an empty array.
  ...getModuleRoutes(),
  ...portalRoutes,
]);
// CONS-N03: the five router-config `future` flags formerly opted in here
// (v7_relativeSplatPath, v7_fetcherPersist, v7_normalizeFormMethod,
// v7_partialHydration, v7_skipActionErrorRevalidation) became the only
// behavior in React Router v7 at the CEO-D-300 upgrade (2026-08-22) — the
// `future` option is gone from `createBrowserRouter` because there is no
// longer an opt-in to make. This app was already running those v7
// behaviors under v6 (plain CSR data router — no route `loader`/`action`,
// no `useFetcher`, no `<Form>`; the sole `path: '*'` splat in
// `routes/auth.tsx` is a leaf catch-all with no relative-link descendants),
// so the upgrade changed no runtime behavior, only removed the now-dead
// config. See `src/App.tsx` for the matching `v7_startTransition` removal.
